import { Link } from "react-router-dom";
import { openCookiePrefs } from "@/components/CookieBanner";

export default function CookiePage() {
  return (
    <div className="legal-page" data-testid="cookie-page">
      <Link to="/" className="ghost-link" style={{ display: "inline-block", marginBottom: 40 }}>Back to Pord.</Link>

      <h1 className="page-title" style={{ fontSize: "clamp(1.8rem,5vw,2.8rem)", marginBottom: 8 }}>Cookie Policy</h1>
      <p className="muted-caption">Effective: April 11, 2026 | Last updated: April 11, 2026</p>

      <h3>What Cookies We Use</h3>
      <p>We use cookies to keep this page running and improve your experience. Simply continue or click "Noted" to acknowledge our cookie policy.</p>

      <h3>Essential Cookies</h3>
      <p>Keeps the experience running. Cannot be disabled. These cookies are necessary for the website to function, including session management and cookie consent preferences.</p>

      <h3>Personalization Cookies</h3>
      <p>Remembers your progress and preferences. These help us provide a seamless experience as you navigate through the Pord. capsule.</p>

      <h3>Analytics Cookies</h3>
      <p>Helps us understand what's resonating. No ads. We may use analytics cookies to understand how visitors interact with our website. No personal data is shared with third parties for advertising.</p>

      <h3>Manage Your Preferences</h3>
      <p>You can manage your cookie preferences at any time by clicking the button below or via the "Cookie" link in the footer.</p>

      <button className="cta-pill" onClick={openCookiePrefs} style={{ marginTop: 8 }}>Open Cookie Preferences</button>

      <h3>Contact</h3>
      <p>For questions about our cookie practices, contact us at info@clarityjournalbyenquips.com.</p>

      <p>See our full <Link to="/privacy" className="ghost-link" style={{ textDecoration: "underline" }}>Privacy Policy</Link> for more details on how we handle your data.</p>

      <div style={{ marginTop: 60 }}>
        <Link to="/" className="cta-pill" data-testid="back-to-pord-btn">Back to Pord.</Link>
      </div>
    </div>
  );
}
